import Marquee from "react-fast-marquee";

const ITEMS = [
  "Landscape Construction",
  "Irrigation Systems",
  "Hydro-Seeding",
  "French Drains",
  "Turf Grooming",
  "Heavy Equipment",
  "Weed Control",
  "Spring Start-Up",
];

export const EditorialMarquee = () => {
  return (
    <div
      className="relative border-y border-white/10 bg-surface py-6 overflow-hidden"
      data-testid="marquee"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {ITEMS.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-bold uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl text-outline mx-6">
              {item}
            </span>
            <span className="h-2 w-2 rounded-full bg-brand mx-6" />
          </div>
        ))}
      </Marquee>
    </div>
  );
};
